import React from 'react';
import DebugOptionsService from 'services/DebugOptions.service';
import DebugBar from './DebugBar';
import DebugGridHelper from './DebugGridHelper';

const DebugComponents = () => {
  if (!DebugOptionsService.isDebug()) {
    return null;
  }
  return (
    <React.Fragment>
      <DebugBar />
      <DebugGridHelper />
    </React.Fragment>
  );
};

export default DebugComponents;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/index.jsx